export enum GroupMemberAction {
  ADD = 'add',
  REMOVE = 'remove',
}
